import "./LayoutWrapper.css";
import logoBlanco from "../assets/images/logo-blanco.png";
import { ArrowLeftOutlined } from '@ant-design/icons';

const LayoutWrapper = ({ children }) => {
  const handleGoBack = () => {
    window.location.href = "https://interactuar.org.co/quiero-credito/credito-para-el-agro/";
  };

  return (
    <div className="app-layout">
      <nav className="navbar">
        <div className="navbar-content">
          <div className="navbar-left"></div>
          <div className="navbar-right">
            <img
              src={logoBlanco}
              alt="Logo"
              className="navbar-logo"
            />
          </div>
        </div>
      </nav>

      <nav className="secondary-navbar">
        <div className="secondary-navbar-content">
          <button 
            className="back-button"
            onClick={handleGoBack}
            aria-label="Regresar"
          >
            <ArrowLeftOutlined />
          </button>
          <h1 className="navbar-title">¡Simula tu crédito Agro!</h1>
        </div>
      </nav>

      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default LayoutWrapper;